import React from 'react';
import PropTypes from 'prop-types';
import Tab from 'react/containers/layout/tabs/Tab';
import Filter from 'react/components/RouteMonitor/RoutesList/Filter';
import List from 'react/components/RouteMonitor/RoutesList/list/List';

import { fixGridAndFilterBuilder } from 'react/utils/utils';
import RoutePanel from 'react/components/RouteMonitor/RoutePanel/RoutePanel';
import MapLoadingOverlay from 'react/components/RouteMonitor/MapLoadingOverlay';
import ShortStopDetailsModal from 'react/containers/modals/ShortStopDetailsModal';
import { actionCreators } from 'react/api/actions/monitor';
import EquipmentStatusCaption from 'react/components/RouteMonitor/EquipmentStatusCaption';
import StopStatusCaption from 'react/components/Maps/StopStatusCaption';

class RouteMonitor extends Tab {

  static propTypes = {
    onClose: PropTypes.func,
    active: PropTypes.bool,
  }

  static tabName = 'VehiclesTracker'

  activeClassName = 'is-active'

  state = {
    cardViewMode: 'comfortable',
  }

  toggleViewMode = () => {
    this.setState({
      cardViewMode:
        this.state.cardViewMode === 'comfortable' ? 'compact' : 'comfortable'
    });
  }

  componentWillUnmount() {
    window.globalStore.dispatch(actionCreators.clearState());
  }

  componentDidMount() {
    try {
      App.Objects.EventNotifications = new App.Routers.EventNotifications();
      App.Objects.RouteMonitor = new App.Routers.RouteMonitor();
      App.Objects.RouteMonitor.show();
    } catch (error) {
      console.log(error);
    }
  }

  componentDidUpdate(prevProps) {
    const { active } = this.props;
    const isComingFromAnotherTab = active !== prevProps.active;

    if (active && isComingFromAnotherTab) {
      Monet.Session.mainMap.map.invalidateSize();
      fixGridAndFilterBuilder();
    }
  }

  render() {
    const { active } = this.props;
    const { cardViewMode } = this.state;
    const className = `gmTabs__panel ${(active) ? this.activeClassName : ''}`;

    return (
      <div data-testid="route-monitor" id="RouteMonitor" className={className}>
        <div id="Maps">
          <div className="container">
            <div id="routeMonitorRoutesContainer">
              <Filter
                cardViewMode={cardViewMode}
                toggleViewMode={this.toggleViewMode}
              />
              <List cardViewMode={cardViewMode} />
            </div>
            <RoutePanel />

            <div id="adjustsLayoutContainer">
              <div id="alertEventUrgentInMap" />
              <div id="mapToolbar" />
              <div id="mapContainer" />
              <div className="status-legends-container">
                <EquipmentStatusCaption />
                <StopStatusCaption />
              </div>
              <MapLoadingOverlay />
              <ShortStopDetailsModal />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RouteMonitor;
